import { t } from "i18next";
import { InfoPros, InfoType } from "interface/index";
import { resetStore } from "store/error";

export const INFORMATION_TYPES: { [key: string]: InfoPros } = {
    accessDenied: {
        title: t("AccessDenied"),
        show: true,
        description: t("UploadAccessDeniedMessage"),
        infoType: "Error",
        actions: [
            {
                text: t("OK"),
                btn: resetStore,
                disabled: false,
                bgColor: "",
                textColor: "",
            },
        ],
    }
}
export const infoHandler = (type:InfoType = "Error", title: string, description: string, actions?: any[]): InfoPros => {
    
    return {
        title,
        show: true,
        description,
        infoType: type,
        actions: actions ?? [
            {
                text: t("OK"),
                btn: resetStore,
                disabled: false,
                bgColor: "",
                textColor: "",
            },
        ],
    }
}
